<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-2" icon="fa fa-address-book-o" titulo="CADASTRO DE CLIENTE">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-id-card-o mr-1 text-info"></i>
              CÓDIGO: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
            </span>
            <span v-if="registro.NOME" class="mx-2">•</span>
            <span v-if="registro.NOME" class="mr-2">
              <i class="fa fa-user mr-1 text-info"></i>
              {{registro.NOME.substring(0,30)}}
            </span>
            
            <div class="ml-3 d-flex align-items-center">
              <b-badge :variant="registro.STATUS === 'ATIVO' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2">
                {{registro.STATUS}}
              </b-badge>
              
              <b-badge v-if="registro.OP_CLIENTE === '1'" variant="info" pill class="px-3 py-1 shadow-sm mr-2">
                CLIENTE
              </b-badge>
              
              <b-badge v-if="registro.OP_FORNECEDOR === '1'" variant="warning" pill class="px-3 py-1 shadow-sm mr-2">
                FORNECEDOR
              </b-badge>

              <b-badge variant="light" pill class="px-3 py-1 shadow-sm text-dark">
                {{ registro.FIZ_JUR === '0' ? 'PESSOA FÍSICA' : (registro.FIZ_JUR === '1' ? 'PESSOA JURÍDICA' : 'ESTRANGEIRO') }}
              </b-badge>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="gravar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <!-- Summary Bar -->
      <b-row class="mb-4 px-1">
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Limite de Crédito</small>
            <h4 class="mb-0 font-weight-bold text-dark">
              {{ registro.OP_CLIENTE === '1' ? (registro.VL_CREDITO ? registro.VL_CREDITO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00') : '—' }}
            </h4>
          </div>
        </b-col>
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Controle de Crédito</small>
            <h5 class="mb-0 font-weight-bold text-dark">
              {{ textoControleCredito }}
            </h5>
          </div>
        </b-col>
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Situação ICMS</small>
            <h5 class="mb-0 font-weight-bold text-dark">
              {{ textoIcms }}
            </h5>
          </div>
        </b-col>
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-success" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Localização</small>
            <h5 class="mb-0 font-weight-bold text-dark">
              {{ textoLocalizacao }}
            </h5>
          </div>
        </b-col>
      </b-row>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Identificação e Dados Básicos -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-id-card"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Identificação e Dados Básicos</h6>
                  <small class="text-muted">Tipo de cadastro, pessoa e documentos principais</small>
                </div>
              </div>
            </template>

            <b-row class="mb-4 align-items-center">
              <b-col sm="2">
                <label class="modal-label-premium d-block mb-2">Tipo de Cadastro</label>
                <div class="d-flex">
                  <b-form-checkbox id="checkbox1" v-model="registro.OP_CLIENTE" value="1" unchecked-value="0" class="mr-3">
                    Cliente
                  </b-form-checkbox>
                  <b-form-checkbox id="checkbox2" v-model="registro.OP_FORNECEDOR" value="1" unchecked-value="0">
                    Fornecedor
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium d-block mb-2">Status</label>
                <b-form-checkbox id="checkbox-status" v-model="registro.STATUS" value="ATIVO" switch unchecked-value="INATIVO">
                  {{ registro.STATUS === 'ATIVO' ? 'Ativo' : 'Inativo' }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium">Código</label>
                <b-form-input type="text" id="ID" :disabled="true" placeholder="Automático" v-model="registro.CODIGO" class="rounded-pill shadow-xs bg-light"></b-form-input>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium">Tipo de Pessoa *</label>
                <b-form-select ref="edFIZ_JUR" :plain="true" :disabled="desabilitado" v-model="registro.FIZ_JUR" :state="valFIZ_JUR" :options="options" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
              <b-col sm="4" v-if="registro.FIZ_JUR === '1'">
                <label class="modal-label-premium">CNPJ *</label>
                <b-input-group>
                  <the-mask class="form-control rounded-pill-left shadow-xs" id="edCNPJ" ref="edCNPJ" mask="##.###.###/####-##" placeholder="00.000.000/0000-00" v-model="registro.CGC" :class="{ 'is-invalid': !valCGC, 'is-valid': valCGC }"></the-mask>
                  <b-input-group-append>
                    <b-button variant="soft-primary" class="rounded-pill-right shadow-xs px-3 font-weight-bold" @click.stop.prevent="consultarJuridica()">
                      <i class="fa fa-search mr-1"></i> Consultar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col sm="4" v-if="registro.FIZ_JUR === '0'">
                <label class="modal-label-premium">CPF *</label>
                <the-mask class="form-control rounded-pill shadow-xs" id="edCPF" ref="edCPF" mask="###.###.###-##" placeholder="000.000.000-00" v-model="registro.CGC" :class="{ 'is-invalid': !valCGC, 'is-valid': valCGC }"></the-mask>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="8">
                <label class="modal-label-premium">Nome Fantasia *</label>
                <b-form-input type="text" id="nomefantasia"  placeholder="Informe o Nome de Fantasia" v-model="registro.NOME" :state="valNOME" class="rounded-pill shadow-xs"></b-form-input>
                
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">ICMS *</label>
                <b-form-select :plain="true" v-model="registro.ISENTO_ICMS" :state="valISENTO_ICMS" :options="optionsIcms" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col sm="8">
                <label class="modal-label-premium">Razão Social *</label>
                <b-form-input type="text" id="razaosocial"  placeholder="Informe a Razão Social" v-model="registro.RAZAOSOCIAL" :state="valRAZAOSOCIAL" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Inscrição Estadual</label>
                <the-mask class="form-control rounded-pill shadow-xs" id="inscestadual" mask="##############" placeholder="Somente números" :class="{ 'is-invalid': !valINS_EST, 'is-valid': valINS_EST }" v-model="registro.INS_EST"></the-mask>                
              </b-col>
            </b-row>
          </b-card>

          <!-- Endereço e Localização -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-map-marker"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Endereço e Localização</h6>
                  <small class="text-muted">Dados geográficos e de entrega</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="3">
                <label class="modal-label-premium">CEP *</label>
                <b-overlay :show="cep.busy" rounded="pill" opacity="0.6" @hidden="onHidden_botaoGerarCEP()">
                  <b-input-group>
                    <the-mask class="form-control rounded-pill-left shadow-xs" id="edCEP" ref="edCEP" mask="#####-###" placeholder="00000-000" v-model="registro.CEP" :class="{ 'is-invalid': !valCEP, 'is-valid': valCEP }"></the-mask>
                    <b-input-group-append>
                      <b-button variant="soft-success" class="rounded-pill-right shadow-xs px-3 font-weight-bold" :disabled="cep.busy" @click.stop.prevent="onClick_botaoGerarCEP(registro.CEP)">
                        <i class="fa fa-refresh mr-1"></i> Buscar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-overlay>
              </b-col>
              <b-col sm="7">
                <label class="modal-label-premium">Endereço *</label>
                <b-form-input type="text" id="endereco" placeholder="Rua, Avenida, etc." v-model="registro.ENDERECO" :state="valENDERECO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium">Número *</label>
                <b-form-input type="text" id="edNumero" ref="edNumero" placeholder="Nº" v-model="registro.NUMERO" :state="valNUMERO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="4">
                <label class="modal-label-premium">Complemento</label>
                <b-form-input type="text" id="complemento" placeholder="Apto, Bloco, etc." v-model="registro.COMPLEMENTO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Bairro *</label>
                <b-form-input type="text" id="bairro" placeholder="Bairro" v-model="registro.BAIRRO" :state="valBAIRRO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="1">
                <label class="modal-label-premium">UF *</label>
                <b-form-select v-model="registro.ID_UF" :options="estados" value-field="ID" text-field="ID" :state="valID_UF" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
              <b-col sm="3">
                <label class="modal-label-premium">Município *</label>
                <div class="d-flex align-items-center">
                  <b-form-select :plain="true" v-model="registro.ID_MUNICIPIO" :options="municipios" :disabled="municipiosBusy || !registro.ID_UF" :state="valID_MUNICIPIO" value-field="ID" text-field="NOME" class="rounded-pill shadow-xs flex-grow-1"></b-form-select>
                  <b-spinner v-if="municipiosBusy" small class="ml-2 text-primary"></b-spinner>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <!-- Contato -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-phone"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Dados de Contato</h6>
                  <small class="text-muted">Telefones, e-mails e redes</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="4">
                <label class="modal-label-premium">Telefone Principal *</label>
                <the-mask class="form-control rounded-pill shadow-xs" id="telefone" mask="(##) #####-####" placeholder="(00) 00000-0000" v-model="registro.TELEFONE" :class="{ 'is-invalid': !valTELEFONE, 'is-valid': valTELEFONE }"></the-mask>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Telefone Secundário</label>
                <the-mask class="form-control rounded-pill shadow-xs" id="outrotelefone" mask="(##) ####-####" placeholder="(00) 0000-0000" v-model="registro.TELEFONE2"></the-mask>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Nome do Contato *</label>
                <b-form-input type="text" id="contato" placeholder="Pessoa de contato" v-model="registro.CONTATO" :state="valCONTATO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4">
                <label class="modal-label-premium">Web Site</label>
                <b-form-input type="text" id="website" :state="tamanhocampoPagina" placeholder="www.exemplo.com.br" v-model.trim="registro.PAGINA" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">E-mail Principal *</label>
                <b-form-input type="text" id="Email1" placeholder="email@exemplo.com.br" v-model="registro.EMAIL1" :state="valEMAIL1" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">E-mail Secundário</label>
                <b-form-input type="text" id="Email2" placeholder="outro@exemplo.com.br" v-model="registro.EMAIL2" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
            </b-row>
          </b-card>

          <!-- Complementos e Financeiro -->
          <b-row v-if="registro.OP_CLIENTE === '1'" class="px-2">
            <b-col sm="12">
              <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-plus-square"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Complementos do Cliente</h6>
                      <small class="text-muted">Vendedores, transportadoras e preferências</small>
                    </div>
                  </div>
                </template>

                <b-row>
                  <b-col sm="3">
                    <vendedor-pesquisa @retornaId="registro.COD_VEND = $event" :idInicial="registro.COD_VEND" label="Vendedor *" place="Informe o Vendedor" :classe-required="!valCOD_VEND" labelBotao="" :arredondado="true"></vendedor-pesquisa>
                  </b-col>
                  <b-col sm="3">
                    <transportadora-pesquisa @retornaId="registro.COD_TRANSP = $event" :idInicial="registro.COD_TRANSP" :classe-required="!valCOD_TRANSP" label="Transportadora *" place="Informe a Transportadora" labelBotao="" :arredondado="true"></transportadora-pesquisa>
                  </b-col>
                  <b-col sm="2">
                    <label class="modal-label-premium">Consumidor Final</label>
                    <b-form-select :plain="true" v-model="registro.OP_CONSUMIDOR" :options="optionsOP_CONSUMIDOR" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label class="modal-label-premium">Exige Nota Fiscal</label>
                    <b-form-select :plain="true" v-model="registro.OP_EMITE_NOTA_FISCAL" :options="optionsOP_EMITE_NOTA_FISCAL" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                  <b-col sm="2">
                    <label class="modal-label-premium">Cobrança Boleto</label>
                    <b-form-select :plain="true" v-model="registro.OP_EMITE_BOLETO" :options="optionsOP_EMITE_BOLETO" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <b-row v-if="registro.OP_CLIENTE === '1'" class="px-2">
            <b-col sm="4">
              <b-card class="border-0 shadow-sm mb-4 h-100" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-secondary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-money"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Financeiro</h6>
                      <small class="text-muted">Prazos e pagamentos</small>
                    </div>
                  </div>
                </template>

                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Dia de Pagamento</label>
                    <b-form-select :plain="true" v-model="registro.QT_CREDITO" :options="optionsQT_CREDITO" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Forma de Pagamento</label>
                    <b-form-select :plain="true" v-model="registro.FORMA_PAGAMENTO" :options="optionsFORMA_PAGAMENTO" value-field="value" text-field="text" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
                <b-row v-if="registro.FORMA_PAGAMENTO === 'P'" class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Dias para Início Pagto</label>
                    <vue-autonumeric v-model="registro.DIAS_INICIAR_PAGAMENTO" ref="edDIAS_INICIAR_PAGAMENTO" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '0', roundingMethod: 'U', minimumValue: '0' }" :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': valDIAS_INICIAR_PAGAMENTO === false, 'is-valid': valDIAS_INICIAR_PAGAMENTO === true }]"></vue-autonumeric>
                  </b-col>
                </b-row>
                <b-row v-if="registro.FORMA_PAGAMENTO === 'P'" class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Qts Vezes</label>
                    <b-form-select :plain="true" v-model="registro.PRAZO" :options="optionsPRAZO" value-field="value" text-field="text" :state="valPRAZO" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
                <b-row v-if="registro.FORMA_PAGAMENTO === 'P'">
                  <b-col sm="12">
                    <label class="modal-label-premium">Dias entre Parcelas</label>
                    <b-form-select :plain="true" v-model="registro.DIAS_ENTRE_PARCELAS" :options="optionsDIAS_ENTRE_PARCELAS" value-field="value" text-field="text" :state="valDIAS_ENTRE_PARCELAS" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col sm="4">
              <b-card class="border-0 shadow-sm mb-4 h-100" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-danger text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-lock"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Limites e Bloqueios</h6>
                      <small class="text-muted">Controle de crédito</small>
                    </div>
                  </div>
                </template>

                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Tipo de Controle</label>
                    <b-form-select :plain="true" :disabled="!this.permiteAtualizarCredito" v-model="registro.OP_CONTROLE_CREDITO" :options="optionsOP_CONTROLE_CREDITO" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Limite de Crédito R$</label>
                    <vue-autonumeric v-model="registro.VL_CREDITO" :disabled="!this.permiteAtualizarCredito" ref="edVL_CREDITO" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '2', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right font-weight-bold text-primary"></vue-autonumeric>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Máx. Notas em Aberto</label>
                    <vue-autonumeric v-model="registro.NOTAS_ARECEBER" :disabled="!this.permiteAtualizarCredito" ref="edNOTAS_ARECEBER" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '0', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right"></vue-autonumeric>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <label class="modal-label-premium">Max. de Dias Atrasado</label>
                    <vue-autonumeric v-model="registro.MAX_DIAS_ATRASO" :disabled="!this.permiteAtualizarCredito" ref="edMAX_DIAS_ATRASO" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '0', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right"></vue-autonumeric>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col sm="4" v-if="false">
              <b-card class="border-0 shadow-sm mb-4 h-100" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-dark text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-percent"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Desoneração ICMS</h6>
                      <small class="text-muted">Regras tributárias especiais</small>
                    </div>
                  </div>
                </template>

                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Motivo Desoneração</label>
                    <b-form-select :plain="true" v-model="registro.OP_MOTIVO_DESONERACAO" :options="motivosDesoneracao" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="mb-3">
                  <b-col sm="12">
                    <label class="modal-label-premium">Alíquota Desonerada %</label>
                    <vue-autonumeric v-model="registro.VL_ICMS_ALIQUOTA_DESONERA" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: '2', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right"></vue-autonumeric>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <label class="modal-label-premium">Deduz do Produto</label>
                    <b-form-select :plain="true" v-model="registro.OP_IND_DEDUZ_DESONERA" :options="deduzDesonaracao" class="rounded-pill shadow-xs"></b-form-select>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <!-- Observações e Expedição -->
          <b-row class="px-2 mt-4">
            <b-col md="6">
              <b-card class="border-0 shadow-sm mb-4 h-100" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-dark text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-sticky-note"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Observações</h6>
                      <small class="text-muted">Notas e informações adicionais do cadastro</small>
                    </div>
                  </div>
                </template>
                <b-row>
                  <b-col sm="12">
                    <b-form-textarea
                      id="edOBSEND"
                      v-model="registro.OBSEND"
                      placeholder="Informe observações relevantes sobre este cliente..."
                      rows="3"
                      max-rows="6"
                      maxlength="60"
                      class="rounded-lg shadow-xs border-0 bg-light"
                    ></b-form-textarea>
                    <small class="text-muted float-right">{{ (registro.OBSEND || '').length }}/60</small>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col md="6">
              <b-card class="border-0 shadow-sm mb-4 h-100" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-truck"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Expedição e Nota fiscal</h6>
                      <small class="text-muted">Observações para logística e faturamento</small>
                    </div>
                  </div>
                </template>
                <b-row>
                  <b-col sm="12">
                    <b-form-textarea
                      id="edOBSREP"
                      v-model="registro.OB_OBSERVACOES_REPRESENTACAO"
                      placeholder="Informações que devem sair na nota ou expedição..."
                      rows="3"
                      max-rows="6"
                      maxlength="254"
                      class="rounded-lg shadow-xs border-0 bg-light"
                    ></b-form-textarea>
                    <small class="text-muted float-right">{{ (registro.OB_OBSERVACOES_REPRESENTACAO || '').length }}/254</small>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>

          <!-- Contas Bancárias -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center">
                  <div class="bg-indigo text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px; background-color: #6610f2 !important;">
                    <i class="fa fa-university"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 font-weight-bold">Contas Bancárias</h6>
                    <small class="text-muted">Gerenciamento de contas para transações</small>
                  </div>
                </div>
                <b-button v-if="registro.CODIGO" variant="soft-primary" size="sm" pill class="px-3" @click="abrirModalConta()">
                  <i class="fa fa-plus mr-1"></i> Adicionar Conta
                </b-button>
              </div>
            </template>

            <div v-if="!registro.CODIGO" class="text-center py-4">
              <i class="fa fa-info-circle text-warning fa-2x mb-2"></i>
              <p class="mb-0 text-muted">Salve o cadastro do cliente primeiro para gerenciar contas bancárias.</p>
            </div>

            <div v-else>
              <b-table 
                v-if="contasBancarias.length > 0"
                :items="contasBancarias" 
                :fields="fieldsContas" 
                responsive="sm" 
                hover 
                striped 
                class="mb-0 shadow-xs rounded overflow-hidden"
                head-variant="light"
              >
                <template #cell(OP_PREFERENCIAL)="data">
                  <b-badge :variant="data.value === '1' ? 'success' : 'light'" pill>
                    {{ data.value === '1' ? 'SIM' : 'NÃO' }}
                  </b-badge>
                </template>
                <template #cell(acoes)="data">
                  <div class="d-flex justify-content-end">
                    <b-button size="sm" variant="outline-success" class="mr-1 rounded-pill" title="Definir como Preferencial" @click="definirPreferencial(data.item.ID)" v-if="data.item.OP_PREFERENCIAL !== '1'">
                      <i class="fa fa-star-o"></i>
                    </b-button>
                    <b-button size="sm" variant="soft-info" class="mr-1 rounded-pill" @click="editarConta(data.item)">
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button size="sm" variant="soft-danger" class="rounded-pill" @click="excluirConta(data.item.ID)">
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
              <div v-else class="text-center py-3 bg-light rounded border-dashed">
                <span class="text-muted small">Nenhuma conta bancária cadastrada.</span>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- Modal de Conta Bancária -->
      <b-modal id="modal-conta" v-model="modalConta" centered title="Conta Bancária" header-bg-variant="primary" header-text-variant="white" hide-footer>
        <b-form @submit.prevent="salvarConta">
          <b-row>
            <b-col sm="12" class="mb-3">
              <label class="modal-label-premium">Banco</label>
              <b-form-input v-model="contaSelecionada.TX_BANCO" placeholder="Ex: Banco do Brasil" required class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="mb-3">
              <label class="modal-label-premium">Agência</label>
              <b-form-input v-model="contaSelecionada.TX_AGENCIA" placeholder="0000-0" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
            <b-col sm="6" class="mb-3">
              <label class="modal-label-premium">Conta</label>
              <b-form-input v-model="contaSelecionada.TX_CONTA" placeholder="0000000-0" required class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" class="mb-3">
              <b-form-checkbox v-model="contaSelecionada.OP_TERCEIRO" value="1" unchecked-value="0" switch>
                Conta de Terceiro
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row v-if="contaSelecionada.OP_TERCEIRO === '1'">
            <b-col sm="12" class="mb-3">
              <label class="modal-label-premium">Nome do Terceiro</label>
              <b-form-input v-model="contaSelecionada.TX_NOME_TERCEIRO" placeholder="Nome completo" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
            <b-col sm="12" class="mb-3">
              <label class="modal-label-premium">CPF/CNPJ do Terceiro</label>
              <b-form-input v-model="contaSelecionada.TX_NUM_DOCUMENTO" placeholder="Documento" class="rounded-pill shadow-xs"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" class="mb-3">
              <label class="modal-label-premium">Tipo de Conta</label>
              <b-form-select v-model="contaSelecionada.OP_TIPO_CONTA" :options="optionsTipoConta" class="rounded-pill shadow-xs"></b-form-select>
            </b-col>
          </b-row>
          <hr>
          <div class="d-flex justify-content-end">
            <b-button variant="light" pill class="mr-2 px-4 shadow-sm" @click="modalConta = false">Cancelar</b-button>
            <b-button type="submit" variant="primary" pill class="px-4 shadow-sm font-weight-bold">
              <i class="fa fa-save mr-1"></i> Salvar Conta
            </b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import HeaderPadrao from '../../../components/Cec/HeaderPadrao.vue'
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import TabelaPrecoPesquisa from '../../pesquisa/TabelaPrecoPesquisa.vue'
import TransportadoraPesquisa from '../../pesquisa/TransportadoraPesquisa.vue'
import {Money} from 'v-money'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'

export default {
  data () {
    return {
      desabilitado: true,
      items: [],
      registro: [],
      estados: [],
      municipios: [],
      municipiosBusy: false,
      isLoading: false,
      status: '',
      permiteAtualizarCredito: false,
      cep: {
        busy : false,
        submmited : false
      },
      optionsPRAZO: [],
      optionsOP_CONTROLE_CREDITO: [
        { value: null, text: '' },
        { value: '0', text: '0 - Nenhum (Desbloqueado)' },
        { value: '1', text: '1 - Limite de Crédito' },
        { value: '2', text: '2 - Máx. de Notas em Aberto' },
        { value: '3', text: '3 - Máx. de Dias Atrasado' },
        { value: '4', text: '4 - BLOQUEADO' }
      ],
      options: [
        { value: null, text: 'Informe a Pessoa' },
        { value: '0', text: 'Física' },
        { value: '1', text: 'Jurídica' },
        { value: '2', text: 'Extrangeiro' }
      ],
      optionsIcms: [
        { value: '0', text: 'Contribuinte' },
        { value: '1', text: 'Isento' },
        { value: '2', text: 'Não Contribuinte' }
      ],
      optionsQT_CREDITO: [
        { value: null, text: 'Opcional' },
        {value: '1', text: '1 - Segunda'},
        {value: '2', text: '2 - Terça'},
        {value: '3', text: '3 - Quarta'},
        {value: '4', text: '4 - Quinta'},
        {value: '5', text: '5 - Sexta'},
        {value: '6', text: '6 - Sábado'},
        {value: '7', text: '7 - Domingo'}
      ],
      motivosDesoneracao: [
        { value: null, text: '' },
        {value: '1', text:  'Táxi'},
        {value: '2', text:  'Deficiente Fisico'},
        {value: '3', text:  'Produtor Agropecuário'},
        {value: '4', text:  'Frotista/Locadora'},
        {value: '5', text:  'Diplomático/Consultar'},
        {value: '6', text:  'Amazônia Livre Comercio'},
        {value: '7', text:  'SUFRAMA'},
        {value: '8', text:  'Venda Orgãos Púiblicos'},
        {value: '9', text:  'Outros'},
        {value: '10', text: 'Deficiente Condutor'},
        {value: '11', text: 'Deficiente não Condutor'},
        {value: '12', text: 'Órgão Fomento'},
        {value: '16', text: 'Olimpieda Rio 2016'},
        {value: '90', text: 'Solicitado Fisco'}
      ],
      deduzDesonaracao: [
        { value: null, text: '' },
        {value: '0', text:  'Não'},
        {value: '1', text:  'Sim'},
        
      ],
      optionsOP_CONSUMIDOR: [
        { value: null, text: '' },
        {value: '0', text:  'Não'},
        {value: '1', text:  'Sim'},
        
      ],
      optionsOP_EMITE_NOTA_FISCAL: [
        { value: null, text: '' },
        {value: '0', text:  'Não'},
        {value: '1', text:  'Sim'},
        
      ],
      optionsOP_EMITE_BOLETO: [
        { value: null, text: '' },
        {value: '0', text:  'Não'},
        {value: '1', text:  'Sim'},
        
      ],
      
      quantasVezes: [],
      diasIniciarPagto: [],
      optionsDIAS_ENTRE_PARCELAS: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      submmited: false,
      contasBancarias: [],
      fieldsContas: [
        { key: 'TX_BANCO', label: 'Banco', sortable: true },
        { key: 'TX_AGENCIA', label: 'Agência' },
        { key: 'TX_CONTA', label: 'Conta' },
        { key: 'OP_PREFERENCIAL', label: 'Pref.', class: 'text-center' },
        { key: 'acoes', label: '', class: 'text-right' }
      ],
      contaSelecionada: {
        ID: null,
        ID_CLIENTE: null,
        TX_BANCO: '',
        TX_CONTA: '',
        TX_AGENCIA: '',
        OP_TERCEIRO: '0',
        TX_NOME_TERCEIRO: '',
        OP_TIPO_CONTA: 'C',
        OP_PREFERENCIAL: '0',
        TX_NUM_DOCUMENTO: ''
      },
      modalConta: false,
      optionsTipoConta: [
        { value: 'C', text: 'Corrente' },
        { value: 'P', text: 'Poupança' }
      ]
    }
  },
  components: {
    VueButtonSpinner,
    HeaderPadrao,
    VendedorPesquisa,
    TabelaPrecoPesquisa,
    TransportadoraPesquisa,
    Money,
    axios,
    VueAxios,
    VueAutonumeric
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    valTipoCadastro(){
      return ( (this.registro.OP_CLIENTE == '0') && 
              (this.registro.OP_FORNECEDOR == '0') ) ? false : true
    },
    valFIZ_JUR(){
      return ((this.registro.FIZ_JUR ) && (this.registro.FIZ_JUR != '')) ? true : false
    },
    valNOME(){
      return ((this.registro.NOME ) && (this.registro.NOME != '')) ? true : false
    },
    valRAZAOSOCIAL(){
      return ((this.registro.RAZAOSOCIAL ) && (this.registro.RAZAOSOCIAL != '')) ? true : false
    },
    valCGC(){
      return ((this.registro.CGC ) && (this.registro.CGC != '')) ? true : false
    },
    validarCEP() {
        // Expressão regular para validar o formato do CEP
        var regexCEP = /^[0-9]{8}$/;
        // Testa se o CEP corresponde à expressão regular
        if (regexCEP.test(this.registro.CEP)) {
            return true; // O CEP é válido
        } else {
            return false; // O CEP é inválido
        }
    },
    valCEP(){
      return ((this.registro.CEP ) && (this.registro.CEP != '')) ? true : false
    },
    valENDERECO(){
      return ((this.registro.ENDERECO ) && (this.registro.ENDERECO != '')) ? true : false
    },
    textoControleCredito() {
      if (!this.registro.OP_CONTROLE_CREDITO) return 'Nenhum'
      const opt = this.optionsOP_CONTROLE_CREDITO.find(o => o.value === this.registro.OP_CONTROLE_CREDITO)
      if (!opt) return 'Nenhum'
      const parts = opt.text.split(' - ')
      return parts.length > 1 ? parts[1] : opt.text
    },
    textoIcms() {
      if (!this.registro.ISENTO_ICMS) return 'Não Informado'
      const opt = this.optionsIcms.find(o => o.value === this.registro.ISENTO_ICMS)
      return opt ? opt.text : 'Não Informado'
    },
    textoLocalizacao() {
      if (!this.registro.ID_UF) return '—'
      const mun = this.municipios.find(m => m.ID === this.registro.ID_MUNICIPIO)
      const nomeMun = mun ? mun.NOME : '—'
      return nomeMun + ' / ' + this.registro.ID_UF
    },
    valNUMERO(){
      return ((this.registro.NUMERO ) && (this.registro.NUMERO != '')) ? true : false
    },
    valID_UF(){
      return ((this.registro.ID_UF ) && (this.registro.ID_UF != '')) ? true : false
    },
    valID_MUNICIPIO(){
      return ((this.registro.ID_MUNICIPIO ) && (this.registro.ID_MUNICIPIO != '')) ? true : false
    },
    valINS_EST(){
      return ((this.registro.INS_EST ) && (this.registro.INS_EST != '')) ? true : false
    },
    valISENTO_ICMS(){
      return !!this.registro.ISENTO_ICMS 
    },
    valBAIRRO(){
      return ((this.registro.BAIRRO ) && (this.registro.BAIRRO != '')) ? true : false
    },
    valTELEFONE(){
      return ((this.registro.TELEFONE ) && (this.registro.TELEFONE != '')) ? true : false
    },
    valCONTATO(){
      return ((this.registro.CONTATO ) && (this.registro.CONTATO != '')) ? true : false
    },
    valEMAIL1(){
      return ((this.registro.EMAIL1 ) && (this.registro.EMAIL1 != '')) ? true : false
    },
    valCOD_VEND(){
      return ((this.registro.COD_VEND ) && (this.registro.COD_VEND != '')) ? true : false
    },
    valCOD_TRANSP(){
      return ((this.registro.COD_TRANSP ) && (this.registro.COD_TRANSP != '')) ? true : false
    },
    valDIAS_INICIAR_PAGAMENTO() {
      // Não valida se for fornecedor
      if (this.registro.OP_CLIENTE !== '1') return null
      // Não valida se não tiver forma de pagamento selecionada
      if (!this.registro.FORMA_PAGAMENTO) return null
      
      const dias = Number(this.registro.DIAS_INICIAR_PAGAMENTO)
      
      if (this.registro.FORMA_PAGAMENTO === 'V') {
        // À Vista: deve ser exatamente 0
        return dias == 0 ? true : false
      } else if (this.registro.FORMA_PAGAMENTO === 'P') {
        // A Prazo: deve ser > 0
        return dias > 0 ? true : false
      }
      return null
    },
    valPRAZO() {
      // Não valida se for fornecedor
      if (this.registro.OP_CLIENTE !== '1') return null
      // Não valida se não tiver forma de pagamento selecionada
      if (!this.registro.FORMA_PAGAMENTO) return null
      
      const prazo = Number(this.registro.PRAZO)
      
      if (this.registro.FORMA_PAGAMENTO === 'V') {
        // À Vista: deve ser 1
        return prazo == 1 ? true : false
      } else if (this.registro.FORMA_PAGAMENTO === 'P') {
        // A Prazo: deve ser > 0
        return prazo > 0 ? true : false
      }
      return null
    },
    valDIAS_ENTRE_PARCELAS() {
      // Não valida se for fornecedor
      if (this.registro.OP_CLIENTE !== '1') return null
      // Não valida se não tiver forma de pagamento selecionada
      if (!this.registro.FORMA_PAGAMENTO) return null
      
      const diasEntre = Number(this.registro.DIAS_ENTRE_PARCELAS)
      const prazo = Number(this.registro.PRAZO)
      
      if (this.registro.FORMA_PAGAMENTO === 'V') {
        // À Vista: deve ser 0 ("No dia da Primeira")
        return diasEntre == 0 ? true : false
      } else if (this.registro.FORMA_PAGAMENTO === 'P') {
        // A Prazo:
        // Se tiver apenas 1 parcela (1x), dias entre parcelas deve ser 0
        if (prazo === 1) {
          return diasEntre == 0 ? true : false
        }
        // Se tiver mais de uma parcela, deve ser >= 2 (não pode ser null, 0 ou 1)
        if (prazo > 1) {
          if (this.registro.DIAS_ENTRE_PARCELAS === null || 
              this.registro.DIAS_ENTRE_PARCELAS === undefined ||
              diasEntre == 0 || 
              diasEntre == 1) {
            return false
          }
          return diasEntre >= 2 ? true : false
        }
        return null
      }
      return null
    },
    tamanhocampoPagina () {
      if (this.registro.PAGINA) {
        return this.registro.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  methods: {
    async consultarJuridica() {
      if (!this.registro.CGC) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o CNPJ para consultar!')
        this.$refs.edCNPJ.$el.focus()
        return
      }
      const bodyGerar = {
        cnpj: this.registro.CGC
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        const {data} = await this.$http.post('/api/protected/integrador/consultarJuridica', bodyGerar)

        if ((data.status === 'success') && (data.data)) {
          const dadosCliente = data.data
          
          this.registro.NOME = dadosCliente.nome
          this.registro.RAZAOSOCIAL = dadosCliente.razao
          this.registro.INS_EST = dadosCliente.inscricaoEstadual
          this.registro.CEP = dadosCliente.cep
          this.registro.ENDERECO = dadosCliente.endereco
          this.registro.COMPLEMENTO = dadosCliente.complemento
          this.registro.BAIRRO = dadosCliente.bairro
          this.registro.NUMERO = dadosCliente.numero
          this.registro.ID_UF = dadosCliente.ufId
          this.registro.ID_MUNICIPIO = dadosCliente.municipioId
          this.registro.TELEFONE = dadosCliente.telefone
          this.registro.EMAIL1 = dadosCliente.email
          this.$store.commit('controle/setAguardando', false)
        } else {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'CNPJ não localizado!')
        }
        
      } catch (err) {
        this.$store.commit('controle/setAguardando', false)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
        console.error('Erro ao gerar boleto:', err)
      }
    },

    async voltar() {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('cliente/GET_LISTA')
        this.$router.push('/cadastros/clientes/index')
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao pesquisar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.$nextTick(() => {
          if (this.$refs.edNome) {
            this.$refs.edNome.focus()
          }
        })
      }
      
    },
    onHidden_botaoGerarCEP() {
      // Return focus to the button
      if (this.registro.ENDERECO) {
        this.$refs.edNumero.focus()
      }
    },
    async onClick_botaoGerarCEP(cep) {
      if (this.validarCEP == false) {
        this.$root.$bvToast.toast(`Informe o CEP correto`, {
          title: 'Aviso',
          autoHideDelay: 1000,
          variant: 'danger',
          appendToast: true
        })
        this.$refs.edCEP.$el.focus()
        return
      }
      this.cep.submmited = true
      this.cep.busy = true
      let requisicao = axios.create({
        baseURL: `https://viacep.com.br/`
      })

      try {
          const response = await requisicao.get(`ws/${cep}/json/`)
          if (response.status === 200) {
              if (response.data.erro) {
                this.$root.$bvToast.toast(`CEP não localizado!!!`, {
                  title: 'Aviso',
                  autoHideDelay: 13000,
                  variant: 'warning',
                  appendToast: true
                })
                
                this.$refs.edCEP.$el.focus()
                this.$refs.edCEP.$el.select()
              }
              this.registro.ENDERECO = response.data.logradouro.toUpperCase()
              this.registro.COMPLEMENTO = response.data.complemento.toUpperCase()
              this.registro.BAIRRO = response.data.bairro.toUpperCase()
              this.registro.ID_UF = response.data.uf.toUpperCase()
              await this.getMunicipios()
              this.registro.ID_MUNICIPIO = response.data.ibge.toUpperCase()
              this.cep.busy = false
              this.cep.submmited = false
          } else {
            this.cep.busy = false
            this.cep.submmited = false
            this.$root.$bvToast.toast(`Erro ao consultar o CEP: ${error.message}`, {
              title: 'Aviso',
              autoHideDelay: 13000,
              variant: 'danger',
              appendToast: true
            })
            return null;
          }
      } catch (error) {
          this.cep.busy = false
          this.cep.submmited = false
          this.$root.$bvToast.toast(`Erro ao consultar o CEP: ${error.message}`, {
            title: 'Aviso',
            autoHideDelay: 13000,
            variant: 'danger',
            appendToast: true
          })

          return null;
      }
    },
    async gravar () {
      if (!this.avisos()) {
        return
      }
      
      try {
        this.$store.commit('controle/setAguardando', true)  
        if (!this.registro.CODIGO) {
          let cadastrado = null
          try {  
            cadastrado = await this.$http.post(`/api/protected/cliente/post`, this.registro)
            
            this.$store.commit("cliente/SET_LIMPAR", null)
            this.$store.commit("cliente/SET_NOME", this.registro.NOME)
            
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Registro Cadastrado com Sucesso!' )
            
          } catch(err) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          }

          await this.$store.dispatch('cliente/GET_LISTA')
          this.$store.commit("cliente/SET_REGISTRO_SELECIONADO_ID", cadastrado.data.CODIGO)
          this.$router.push('/cadastros/clientes/index')

        } else {
          try {        
            await this.$http.post(`/api/protected/cliente/edit`, this.registro)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Registro Alterado com Sucesso!' )
          } catch(err) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          }

          await this.$store.dispatch('cliente/GET_LISTA')
          this.$router.push('/cadastros/clientes/index')
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    async getEstados () {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data
        await this.getMunicipios()
      } catch(err) {
        this.estados = []
      }
    },
    async getMunicipios () {
      this.municipiosBusy = true
      
      this.municipios = []
      this.municipiosBusy = false
      
      if (this.registro.ID_UF) {
        try {
          let result = await this.$http.get(`/api/protected/municipios/${this.registro.ID_UF}`)
          this.municipios = result.data
          this.municipiosBusy = false
        } catch(err) {
          this.municipiosBusy = false
        }
      }
      
    },
    limparRegistro () {
      let registroVazio =
        {
          CODIGO: null,
          NOME: null,
          RAZAOSOCIAL: null,
          CGC: null,
          OP_CLIENTE: '1',
          OP_FORNECEDOR: '0',
          FIZ_JUR: '0',
          INS_EST: null,
          INS_SUFRAMA: null,
          ENDERECO: null,
          BAIRRO: null,
          TELEFONE: null,
          TELEFONE2: null,
          NUMERO: null,
          COMPLEMENTO: null,
          CEP: null,
          CONTATO: null,
          EMAIL1: null,
          EMAIL2: null,
          PAGINA: null,
          ID_UF: null,
          VL_CREDITO: 0.00,
          COD_VEND: null,
          TABELA_PRECO_ID: null,
          COD_TRANSP: null,
          FORMA_PAGAMENTO: 'V',  // Padrão: À Vista
          DIAS_INICIAR_PAGAMENTO: 0,
          PRAZO: 1,  // 1 vez (À Vista)
          DIAS_ENTRE_PARCELAS: 0,  // No dia da Primeira
          QT_CREDITO: null,
          ULT_MOV: null,
          OBSEND: null,
          OB_OBSERVACOES_REPRESENTACAO: null,
          ISENTO_ICMS: null,
          ID_MUNICIPIO: null
        }
      this.registro = registroVazio
    },
    async iniciarFormNovo () {
      await this.getEstados()
      await this.limparRegistro()
      this.desabilitado = false
      this.registro.STATUS = 'ATIVO'
    },
    async iniciarFormEditar ( id ) {
      let result = null
      
      try {
        result = await this.$http.get(`/api/protected/cliente/getById/${id}`)
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.go(-1) 
      }
      
      this.registro = (result.data && result.data.length > 0) ? result.data[0] : null
      if (!this.registro) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O Cadastro não foi localizado!' )
        this.$router.go(-1) 
      }
      
      // Garantir que os campos numéricos sejam números e não strings
      if (this.registro.DIAS_INICIAR_PAGAMENTO !== null && this.registro.DIAS_INICIAR_PAGAMENTO !== undefined) {
        this.registro.DIAS_INICIAR_PAGAMENTO = Number(this.registro.DIAS_INICIAR_PAGAMENTO)
      }
      if (this.registro.PRAZO !== null && this.registro.PRAZO !== undefined) {
        this.registro.PRAZO = Number(this.registro.PRAZO)
      }
      if (this.registro.DIAS_ENTRE_PARCELAS !== null && this.registro.DIAS_ENTRE_PARCELAS !== undefined) {
        this.registro.DIAS_ENTRE_PARCELAS = Number(this.registro.DIAS_ENTRE_PARCELAS)
      }
      
      await this.getEstados()
      await this.getContas(id)

    },
    async getContas ( clienteId ) {
      try {
        let result = await this.$http.get(`/api/protected/cliente/conta/getByClienteId/${clienteId}`)
        this.contasBancarias = result.data || []
      } catch (err) {
        console.error(err)
      }
    },
    abrirModalConta ( conta = null ) {
      if (conta) {
        this.contaSelecionada = { ...conta }
      } else {
        this.contaSelecionada = {
          ID: null,
          ID_CLIENTE: this.registro.CODIGO,
          TX_BANCO: '',
          TX_CONTA: '',
          TX_AGENCIA: '',
          OP_TERCEIRO: '0',
          TX_NOME_TERCEIRO: '',
          OP_TIPO_CONTA: 'C',
          OP_PREFERENCIAL: '0',
          TX_NUM_DOCUMENTO: ''
        }
      }
      this.modalConta = true
    },
    editarConta ( conta ) {
      this.abrirModalConta(conta)
    },
    async salvarConta () {
      try {
        let url = this.contaSelecionada.ID ? '/api/protected/cliente/conta/edit' : '/api/protected/cliente/conta/post'
        await this.$http.post(url, this.contaSelecionada)
        
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Conta bancária salva com sucesso!')
        this.modalConta = false
        this.getContas(this.registro.CODIGO)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao salvar conta bancária: ' + err)
      }
    },
    async excluirConta ( id ) {
      if (!confirm('Deseja realmente excluir esta conta bancária?')) return
      
      try {
        await this.$http.post(`/api/protected/cliente/conta/delete/${id}`)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Conta bancária excluída com sucesso!')
        this.getContas(this.registro.CODIGO)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao excluir conta bancária: ' + err)
      }
    },
    async definirPreferencial ( id ) {
      try {
        await this.$http.post(`/api/protected/cliente/conta/definirPreferencial/${id}`)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Conta definida como preferencial!')
        this.getContas(this.registro.CODIGO)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao definir conta preferencial: ' + err)
      }
    },
    async prepararForm () {
      this.optionsFORMA_PAGAMENTO = [
        { value: 'V', text: 'A Vista'},
        { value: 'P', text: 'A Prazo'}
      ]
      
      this.optionsPRAZO = [{value: 0, text: 'Nao parcela A Vista'}] 
      for (let i = 0; i < 48; i++) {
        this.optionsPRAZO.push({ value: (i+1) , text: (i+1)+'X' })
      }

      this.optionsDIAS_ENTRE_PARCELAS = [
        {value: 0, text: 'No dia da Primeira'},
        {value: 1, text: '1 Dia'}
      ]
      for (var i = 2; i <= 29; i++) {
        this.optionsDIAS_ENTRE_PARCELAS.push({value: i, text: i + ' Dias'})
      }
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 30, text: '1 Mes'})
      for (var i = 31; i <= 60; i++) {
        this.optionsDIAS_ENTRE_PARCELAS.push({value: i, text: i + ' Dias'})
      }
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 60, text:  '2 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 90, text:  '3 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 120, text: '4 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 150, text: '5 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 180, text: '6 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 210, text: '7 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 240, text: '8 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 270, text: '9 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 300, text: '10 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 330, text: '11 Meses'})
      this.optionsDIAS_ENTRE_PARCELAS.push({value: 360, text: '1 Ano'})
      
     

      const permissaoPayLoad = {
          login: window.localStorage.getItem('login'),
          permissao: 'AcPropAlterarLimiteCredito'
        }

        let permissaoResult = null
        try {
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
          const permissao = (permissaoResult && permissaoResult.data) ? permissaoResult.data.permissao : null
          this.permiteAtualizarCredito = permissao === true
        } catch (err) {
          this.permiteAtualizarCredito = false
        }

        

    },
      
      validarCNPJ(c) {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      if ((c = c.replace(/[^\d]/g, "")).length != 14)
          return false

      if (/0{14}/.test(c))
          return false

      for (var j = 0; j < 2; ++j) {
          for (var i = 0, n = 0; i < 12 + j; n += c[i] * b[++i - j])
          if (c[12 + j] != ((n %= 11) < 2) ? 0 : 11 - n)
              return false;
      }

      return true
    },
    avisos() {
      let retorno = true
      if (!this.valTipoCadastro) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o tipo de cadastro CLIENTE ou FORNECEDOR!! ' )
        retorno = false
      } 
      if (!this.valNOME) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome \ Nome Fantasia!!' )
      } 
      if (!this.valFIZ_JUR) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Tipo de Pessoa CPF (Fisica) CNPJ(Juridica)!!' )
      } 
      if (!this.validarCNPJ) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe um CNPJ válido!!' )
      } 
      if (!this.valNUMERO) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Numero do Endereço \n Digite S/N para sem Numero!!' )
      } 
      if (!this.valID_UF) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a UF do Cliente!!' )
      } 
      if (!this.valID_MUNICIPIO) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Municipio do Cliente!!' )
      } 
      if (!this.valTELEFONE) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'É necessário informar o telefone válido para a Nota Fiscal!! ' )
      } 
      if (!this.valEMAIL1) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o email preferencial para a Nota Fiscal!!' )
      } 
      if (!this.valCEP) {
        retorno = false
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o CEP válido!!' )
      }
      
      // Validações de forma de pagamento (apenas para clientes)
      if (this.registro.OP_CLIENTE === '1') {
        if (!this.registro.FORMA_PAGAMENTO) {
          // Forma de pagamento não informada
          retorno = false
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Forma de Pagamento (À Vista ou A Prazo)!!')
        } else if (this.registro.FORMA_PAGAMENTO === 'V') {
          // À Vista - os campos devem estar com os valores corretos (usar comparação numérica)
          if (Number(this.registro.DIAS_INICIAR_PAGAMENTO) != 0) {
            retorno = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para pagamento À Vista, o campo Dias para Início Pagto deve ser 0!!')
          }
          if (Number(this.registro.PRAZO) != 1) {
            retorno = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para pagamento À Vista, o campo Qts Vezes deve ser 1!!')
          }
          if (Number(this.registro.DIAS_ENTRE_PARCELAS) != 0) {
            retorno = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para pagamento À Vista, o campo Dias entre Parcelas deve ser "No dia da Primeira"!!')
          }
        } else if (this.registro.FORMA_PAGAMENTO === 'P') {
          // A Prazo - deve ter dias para início > 0 (usar comparação numérica)
          const diasInicio = Number(this.registro.DIAS_INICIAR_PAGAMENTO)
          const prazo = Number(this.registro.PRAZO)
          const diasEntre = Number(this.registro.DIAS_ENTRE_PARCELAS)
          
          if (!this.registro.DIAS_INICIAR_PAGAMENTO || diasInicio <= 0) {
            retorno = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para pagamento A Prazo, informe os Dias para Início do Pagamento (deve ser maior que 0)!!')
          }
          // A Prazo - deve ter quantidade de parcelas > 0
          if (!this.registro.PRAZO || prazo <= 0) {
            retorno = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para pagamento A Prazo, informe a quantidade de parcelas (Qts Vezes deve ser maior que 0)!!')
          }
          // Se tiver apenas 1 parcela, dias entre parcelas deve ser 0
          if (prazo === 1 && diasEntre != 0) {
            retorno = false
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para parcelamento em 1x, o campo Dias entre Parcelas deve ser 0 (No dia da Primeira)!!')
          }
          // Se tiver mais de 1 parcela, dias entre parcelas deve ser >= 2
          if (prazo > 1) {
            if (this.registro.DIAS_ENTRE_PARCELAS === null || 
                this.registro.DIAS_ENTRE_PARCELAS === undefined) {
              retorno = false
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para parcelamento em múltiplas vezes, informe os Dias entre Parcelas (mínimo 2 dias)!!')
            } else if (diasEntre == 0) {
              retorno = false
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para parcelamento em múltiplas vezes, o campo Dias entre Parcelas não pode ser "No dia da Primeira"!!')
            } else if (diasEntre == 1) {
              retorno = false
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Para parcelamento em múltiplas vezes, o campo Dias entre Parcelas não pode ser 1 dia!!')
            } else if (diasEntre < 0) {
              retorno = false
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'O campo Dias entre Parcelas não pode ser negativo!!')
            }
          }
        }
      }
      
      return retorno
    }
  },
  async created () {
    let id = this.$route.params.id
    await this.prepararForm()
    if ( id ) {
      await this.iniciarFormEditar( id )
    } else {
      await this.iniciarFormNovo()
    }

    // Aguarda a renderização completa antes de setar o foco
    this.$nextTick(() => {
      setTimeout(() => {
        if (!id) {
          // Modo novo: foca no campo Tipo de Pessoa
          if (this.$refs.edFIZ_JUR) {
            if (typeof this.$refs.edFIZ_JUR.focus === 'function') {
              this.$refs.edFIZ_JUR.focus()
            } else if (this.$refs.edFIZ_JUR.$el) {
              this.$refs.edFIZ_JUR.$el.focus()
            }
          }
        } else {
          // Modo edição: foca no CPF ou CNPJ conforme o tipo
          if (this.registro.FIZ_JUR === '1') {
            // Pessoa Jurídica - foca no CNPJ
            if (this.$refs.edCNPJ && this.$refs.edCNPJ.$el) {
              this.$refs.edCNPJ.$el.focus()
            }
          } else if (this.registro.FIZ_JUR === '0') {
            // Pessoa Física - foca no CPF
            if (this.$refs.edCPF && this.$refs.edCPF.$el) {
              this.$refs.edCPF.$el.focus()
            }
          }
        }
      }, 100)
    })
  },
  mounted (){
    
  },
  watch: {
    'registro.FORMA_PAGAMENTO': function (val, oldVal) {
      // Usar $nextTick para garantir que as mudanças sejam aplicadas
      this.$nextTick(() => {
        if (val === 'V') {
          // À Vista: setar automaticamente os campos para os valores corretos
          this.registro.DIAS_INICIAR_PAGAMENTO = 0  // 0 dias
          this.registro.PRAZO = 1                    // 1 vez (À Vista)
          this.registro.DIAS_ENTRE_PARCELAS = 0      // "No dia da Primeira"
        } else if (val === 'P') {
          // A Prazo: se estiver vindo de À Vista, limpar os valores (usar comparação numérica)
          if (oldVal === 'V' || (Number(this.registro.DIAS_INICIAR_PAGAMENTO) == 0 && Number(this.registro.PRAZO) == 1)) {
            this.registro.DIAS_INICIAR_PAGAMENTO = null
            this.registro.PRAZO = null
            this.registro.DIAS_ENTRE_PARCELAS = null
          }
        }
      })
    },
    'registro.PRAZO': function (val, oldVal) {
      // Se mudou para 1 parcela, zerar dias entre parcelas (usar comparação numérica)
      if (Number(val) === 1 && this.registro.FORMA_PAGAMENTO === 'P') {
        this.$nextTick(() => {
          this.registro.DIAS_ENTRE_PARCELAS = 0
        })
      }
    },
    'registro.ID_UF': async function () {
      await this.getMunicipios()
    },
    'registro.FIZ_JUR': function () {
      if (this.registro.FIZ_JUR == '0' ) { //Fisica
        this.registro.RAZAOSOCIAL =  this.registro.NOME
      }
      else if (this.registro.FIZ_JUR == '2' ) { //Exterior
        this.registro.INS_EST = null
        this.registro.INS_SUFRAMA = null
      }

    }
  }
}
</script>





// WEBPACK FOOTER //
// src/views/cadastros/clientes/ClientesEdit.vue